import React from 'react';

//import Scss
import './assets/scss/themes.scss';

// Round 12: menutech-style sidebar restyle. Loaded AFTER themes.scss so
// these rules override the Velzon defaults. Delete this line + the file
// to restore the template's original sidebar look.
import './assets/styles/sidebar-menutech.css';

// 3D brand logos: widen the sidebar + give the spinning logo room.
import './assets/styles/brand3d-sidebar.css';
// Round THEME-1: dark-mode fixes + Midnight/Graphite dark variants.
// Loaded LAST so its variable overrides win over the styles above.
// The picker lives in Components/Common/LightDark.js.
import './assets/styles/appDarkThemes.css';
import './assets/styles/epo-sticky-head.css';
// Round M1 — global mobile/tablet responsive layer. Loaded LAST so its
// max-width media queries win over the template and the styles above.
// Desktop rendering is unchanged (every rule is media-scoped).
import './assets/styles/mobile-responsive.css';

//imoprt Route
import Route from './Routes';
import AssistedSessionBanner from './Components/Common/AssistedSessionBanner';   // Round 18

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// Fake Backend 
// Access-Management hardening (Round 9, audit H-9/H-11): the Velzon
// axios-mock "fake backend" (and its sample JWTs) is removed. The app talks
// only to the real API through src/api.js.

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

function App() {
  return (
    <React.Fragment>
      <AssistedSessionBanner />
      <Route />
    </React.Fragment>
  );
}

export default App;
